import { useGetTemplates } from '@features/digitalOnboarding/hooks/useGetTemplates';
import { yupResolver } from '@hookform/resolvers/yup';
import { Close, Done } from '@mui/icons-material';
import { Alert, Autocomplete, Box, Button, Dialog, DialogContent, DialogTitle, IconButton, TextField, Typography } from '@mui/material';
import { FC, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { ShareDocsIcon } from '../../../../vectors/index';
import * as yup from 'yup';
import { LoadingButton } from '@mui/lab';
import { toast } from 'react-toastify';
import { useSendHireDoucments } from '@features/digitalOnboarding/hooks/useSendHireDoucments';

type RestTemplateListProps = {
    handleClose: () => void;
    templeteIds: number[];
    isOpen: boolean;
    applicationId: number;
};

type FormData = {
    template_ids: number[];
};

const schema: yup.ObjectSchema<FormData> = yup
    .object({
        template_ids: yup.array().of(yup.number().required()).required('Documents are required'),
    })
    .required();


const RestTemplateList: FC<RestTemplateListProps> = ({ handleClose, templeteIds, isOpen, applicationId }) => {
    const { templatesData, isLoadingTemplates } = useGetTemplates();
    const [errorText, setErrorText] = useState<string>('');
    const [defaultValues, setDefaultValues] = useState<FormData>({
        template_ids: [],
    });

    const {
        handleSubmit,
        control,
        reset,
        formState: { errors },
    } = useForm<FormData>({
        mode: 'onTouched',
        resolver: yupResolver(schema),
        defaultValues,
    });

    const { sendHireDocuments, isSendindDocuments } = useSendHireDoucments({ setErrorText });

    const onSubmit = (values: FormData) => {
        const options = {
            onSuccess: (data: { status: number; message: string }) => {
                if (data.status === 200) {
                    toast.success(data.message);
                    reset();
                    handleClose();
                }
            },
        };

        const formattedValues = {
            template_ids: values.template_ids.join(',')
        };

        sendHireDocuments(
            { ...formattedValues, application_id: applicationId },
            options
        );
    };

    return (
        <Dialog open={isOpen} onClose={handleClose} maxWidth="xs" fullWidth>
            <DialogTitle>
                <IconButton sx={{ position: 'absolute', top: 5, right: 5 }} onClick={handleClose}>
                    <Close />
                </IconButton>
                <br />
                <ShareDocsIcon />
                <br />
                <Typography variant="h4">
                    Send Additional documents
                </Typography>
            </DialogTitle>
            <DialogContent>
                {errorText && (<Alert sx={{mb: 2}} severity='error'>{errorText}</Alert>)}
                <form onSubmit={handleSubmit(onSubmit)}>
                    <Controller
                        control={control}
                        name="template_ids"
                        render={({ field: { onChange, value } }) => (
                            <Box display="flex" alignItems="center">
                                <Autocomplete
                                    sx={{
                                        flexGrow: 1,
                                        bgcolor: 'white',
                                        borderRadius: 5
                                    }}
                                    options={templatesData?.object.filter((item: { id: number; }) => !templeteIds.includes(item.id)) || []}
                                    value={templatesData?.object.filter((template: { id: number; }) => value.includes(template.id)) || []}
                                    onChange={(
                                        e,
                                        data: {
                                            name: string;
                                            id: string;
                                        }[],
                                    ) => {
                                        const ids = data.map((item) => item.id);
                                        onChange(ids);
                                    }}
                                    multiple
                                    loading={isLoadingTemplates}
                                    getOptionLabel={(option) => option.name || ''}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            placeholder="Select Documents"
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            error={Boolean(errors.template_ids)}
                                            helperText={
                                                errors?.template_ids ? errors?.template_ids.message : ''
                                            }
                                        />
                                    )}
                                />
                            </Box>
                        )}
                    />
                    <LoadingButton
                        type="submit"
                        startIcon={<Done />}
                        variant="contained"
                        size="small"
                        fullWidth
                        sx={{ marginTop: 3 }}
                        loading={isSendindDocuments}
                        loadingPosition="start"
                    >
                        Send
                    </LoadingButton>
                     <Button
                        startIcon={<Close />}
                        variant="outlined"
                        size="small"
                        fullWidth
                        onClick={handleClose}
                        disabled={isSendindDocuments}
                        sx={{ marginTop: 2 }}
                    >
                        Cancel
                    </Button>
                </form>
            </DialogContent>
        </Dialog>
    );
};

export default RestTemplateList;
